import React from 'react';
import { cn } from '../../../utils/cn';

export type DotTone = 'success' | 'warn' | 'danger' | 'idle' | 'brand';

const COLOR: Record<DotTone, string> = {
  success: 'bg-emerald-500',
  warn: 'bg-amber-500',
  danger: 'bg-red-500',
  idle: 'bg-zinc-400',
  brand: 'bg-[var(--rt-brand-500)]',
};

export interface DotProps {
  tone?: DotTone;
  pulse?: boolean;
  className?: string;
}

export const Dot: React.FC<DotProps> = ({
  tone = 'success',
  pulse = true,
  className,
}) => {
  const color = COLOR[tone];
  return (
    <span
      className={cn('relative inline-flex h-2 w-2 shrink-0', className)}
      aria-hidden="true"
    >
      {pulse && (
        <span
          className={cn(
            'absolute inline-flex h-full w-full rounded-full opacity-60 rt-pulse',
            color,
          )}
        />
      )}
      <span
        className={cn('relative inline-flex h-2 w-2 rounded-full', color)}
      />
    </span>
  );
};

export default Dot;
